<script setup lang="ts">
import { useCountryConfig } from '~/composables/useCountryConfig'
import ArrowRight from '~icons/mdi/arrow-right'

const localePath = useLocalePath()
const route = useRoute()
const { homeUrl, registrationPageLogo } = useCountryConfig()

const showRegisterButton = computed(() => {
  return !route.path.includes('/register') && !route.path.includes('/forgot-password')
})
const showLoginButton = computed(() => {
  return route.path.includes('/register') || route.path.includes('/forgot-password')
})
</script>

<template>
  <v-row class="mt-0 mt-md-4">
    <nuxt-link :to="homeUrl" class="mx-2 d-inline-flex align-center">
      <nuxt-picture
        :src="registrationPageLogo"
        width="143"
        class="mx-0 mx-md-8"
        color="primary"
      />
    </nuxt-link>

    <v-spacer />

    <router-link
      v-if="showLoginButton"
      :to="localePath('/login')"
      class="mx-2 mx-md-8 d-inline-flex align-center text-decoration-none"
    >
      <h2 class="font-weight-bold ma-0">
        {{ $t('login.label') }}
      </h2>
      <v-icon :icon="ArrowRight" size="24" color="red-600 mx-1" />
    </router-link>

    <router-link v-if="showRegisterButton" :to="localePath('/register')" class="mx-2 mx-md-8 d-inline-flex align-center text-decoration-none">
      <h2 class="font-weight-bold ma-0">
        {{ $t('register') }}
      </h2>
      <v-icon :icon="ArrowRight" size="24" color="red-600 mx-1" />
    </router-link>
  </v-row>
</template>
